(function (window) {
  'use strict';

  window.initUnbxdCategoryPageViewConfig = function () {
    if (!window.UnxAnalyticsConfig || !window.UnxAnalyticsConfig.pageView) return;
    window.UnxAnalyticsConfig.pageView.events = window.UnxAnalyticsConfig.pageView.events || {};
    var categoryPageViewEvent = window.UnxAnalyticsConfig.pageView.events.category || {};
    window.UnxAnalyticsConfig.pageView.events.category = Object.assign({}, categoryPageViewEvent, {
      urlIdentifiers: { urls: ['/collections/'], exactMatch: false },
      uniqueSelectors: {
        selectors: [
          '#categoryResultsWrapper',
          '.UNX-product-list .product-item',
          'main .product-grid'
        ],
        operation: 'or'
      }
    });
  };

  window.initUnbxdSearchPageViewConfig = function () {
    if (window.patchUnbxdSearchPageViewConfig) {
      window.patchUnbxdSearchPageViewConfig();
    }
  };

  function autoInitUnbxdPageViewConfig() {
    var path = window.location.pathname || '';
    if (path.indexOf('/collections/') !== -1) {
      window.initUnbxdCategoryPageViewConfig();
    } else if (path.indexOf('/search') !== -1) {
      window.initUnbxdSearchPageViewConfig();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInitUnbxdPageViewConfig);
  } else {
    autoInitUnbxdPageViewConfig();
  }
})(window);
